import React from "react";
import { CloudLightning } from "lucide-react";

const StormBanner = ({ status, summary }) => {
  if (!status || status === "none" || status === "clear") return null;
  const warning = status === "warning";
  const bg = warning ? "#EF4444" : "#F59E0B";
  const textMain = warning ? "#ffffff" : "#3A2500";
  const textSub = warning ? "rgba(255,255,255,0.9)" : "rgba(58,37,0,0.85)";
  return (
    <div
      className="go-fade-up flex items-start gap-3 rounded-2xl px-4 py-3.5"
      style={{ background: bg, boxShadow: `0 8px 24px ${warning ? "rgba(239,68,68,0.35)" : "rgba(245,158,11,0.30)"}` }}
      data-testid="storm-banner"
    >
      <span className="mt-0.5 shrink-0"><CloudLightning size={22} color={textMain} strokeWidth={2.4} /></span>
      <div className="min-w-0 flex-1">
        <div className="font-head text-sm font-extrabold uppercase tracking-wide" style={{ color: textMain }}>
          {warning ? "Storm Warning" : "Storm Watch"}
        </div>
        {summary && <div className="mt-0.5 text-sm leading-snug" style={{ color: textSub }}>{summary}</div>}
      </div>
    </div>
  );
};

export default StormBanner;
